module.exports = __webpack_public_path__ + "static/dufner-torascoscopica-5f0641eacd9e34cbdf7265596116d00c.jpg";